export function SAVE_SHOW_GLOBAL_SEARCH(state, [show_global_search]) {
	state.show_global_search = show_global_search
}

export function SAVE_IS_TAG(state, [is_tag]) {
	state.is_tag = is_tag
}
